import * as React from "react";
import PropTypes from "prop-types";
import {Button, Image, List, Message, Segment} from "semantic-ui-react";
import {houseCall__fetchWorkers, loginAsWorker} from "../actions/houseActions";
import Avatar from '../images/avatar-m.gif';
import {SUPPORT_LINK} from "../misc/vars";

export class Workers extends React.PureComponent {
	static propTypes = {
		house: PropTypes.oneOfType([
			PropTypes.number,
			PropTypes.shape({
				house_id: PropTypes.number.isRequired
			})
		]).isRequired
	};
	state = {
		workers: [],
		loaded: false,
		loading: false,
		errors: null,
		logging_in: null,
		logged: null
	};
	
	async componentDidMount() {
		try {
			this.setState({loading: true, errors: null});
			const workers = await houseCall__fetchWorkers(this.props.house);
			this.setState({workers});
		} catch (e) {
			this.setState({errors: e.message || e.error || String(e)});
		} finally {
			this.setState({loading: false, loaded: true});
		}
	}
	
	handleLogin = (worker) => async () => {
		try {
			this.setState({logging_in: worker.workers_id, logged: null});
			await loginAsWorker(worker);
			this.setState({logged: worker.workers_id});
		} catch (e) {
			alert(e.message || e.error || String(e));
		} finally {
			this.setState({logging_in: null});
		}
		
	};
	
	render() {
		const {
			workers,
			loaded,
			loading,
			errors,
			logged,
			logging_in
		} = this.state;
		return (
			<Segment basic loading={loading} style={{minHeight: 200}}>
				{errors ?
					<Message negative>
						<p>{errors}</p>
					</Message>
					:
					<List divided relaxed>
						{workers.map(worker => {
							return (
								<List.Item>
									<Image avatar src={Avatar} floated={"left"}/>
									<List.Header floated={"left"}>
										{worker.name} {worker.first_name} [{worker.email}]
									</List.Header>
									<List.Content floated={"left"}>
										{worker.right_group_id}
									</List.Content>
									<List.Content floated={'right'}>
										{logged === worker.workers_id ?
											<Button positive href={SUPPORT_LINK} target="supprt-login" onClick={() => this.setState({logged: null})}>Öffnen</Button>
											:
											<Button loading={logging_in === worker.workers_id} disabled={null !== logging_in && logging_in !== worker.workers_id} onClick={this.handleLogin(worker)}>Login</Button>
										}
										
									</List.Content>
								</List.Item>
							);
						})}
					</List>
				}
			</Segment>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Workers.js